var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArcViewLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 25,
    fill: "#3141D0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 39,
    width: 21,
    height: 3,
    fill: "#3141D0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 85,
    width: 21,
    height: 3,
    fill: "#3141D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8836 100.908L67.6064 34.4516L72.2495 26.0553C77.323 16.8807 91.1695 19.5382 92.486 29.9392V29.9392L100.175 88.1594",
    stroke: "white",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcViewLogo);
export default __webpack_public_path__ + "static/media/arcViewLogo.1074438334a019fe86edf5adae2ff578.svg";
export { ForwardRef as ReactComponent };